import React from 'react'

const Loading = () => {
  return (
    <center className="loading-screen">
        <div className="loading-brand">
        <h1>Ad</h1>
        <small>aremudami-luxury</small>
        <br />
        <small>Your trusted partner in luxurious real estate success.</small>
        </div>
        <h2 className="loading-spinner"></h2>
    </center>
  )
}

export default Loading
